"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateUser = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@veeam/core");
const common_1 = require("../../../common");
const ErrorMessage_1 = require("../../../ErrorMessage");
const fields_1 = require("../../../fields");
const helpers_1 = require("../../../helpers");
const CreateUser_styles_1 = require("./CreateUser.styles");
const constants_1 = require("./helpers/constants");
const maxLength_1 = require("../../helpers/maxLength");
const hooks_1 = require("../../hooks");
const Notification_1 = require("../../../Notification");
const Spinner_1 = require("../../../Spinner");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
const View_1 = require("../../../View");
exports.CreateUser = react_1.default.memo(function CreateUser({ loading, hasRememberMe = true, texts: customTexts, logIn, maxLengthLogin, maxLengthPassword }) {
    const texts = Object.assign({}, constants_1.CREATE_USER_DEFAULT_TEXTS, customTexts);
    const passwordDontMatchErrorState = (0, helpers_1.useStateValue)('');
    const busyModel = (0, core_1.useModelBuilder)({ loading: false });
    const inputRef = (0, hooks_1.useAutoFocus)();
    const form = (0, core_1.useForm)({ login: '', password: '', passwordConfirm: '', rememberMe: false }, {
        validationSchema: {
            login: [
                (0, core_1.required)(texts.errorRequired),
                (0, maxLength_1.maxLength)(maxLengthLogin, texts.errorMaxLength)
            ],
            password: [
                (0, core_1.required)(texts.errorRequired),
                (0, maxLength_1.maxLength)(maxLengthPassword, texts.errorMaxLength)
            ],
            passwordConfirm: [
                (0, core_1.required)(texts.errorRequired),
                (0, maxLength_1.maxLength)(maxLengthPassword, texts.errorMaxLength)
            ]
        }
    });
    const { value: { loading: internalLoading } } = (0, core_1.useModel)(busyModel);
    const isCapsLockActive = (0, hooks_1.useCapsLockDetector)();
    const onSubmit = (payload) => __awaiter(this, void 0, void 0, function* () {
        if (form.getValue().password !== form.getValue().passwordConfirm) {
            passwordDontMatchErrorState.setValue(texts.errorPasswordDontMatch);
            return;
        }
        passwordDontMatchErrorState.setValue('');
        return logIn === null || logIn === void 0 ? void 0 : logIn(payload);
    });
    const { submit, errorHighlight, fieldFocusHandler, keyDownHandler, hasError, error } = (0, hooks_1.useLoginFormSubmit)({
        form,
        handler: onSubmit,
        busyModel
    });
    loading = loading || internalLoading;
    const hasDontMatchError = !!passwordDontMatchErrorState.getValue();
    const hasMessages = hasError || isCapsLockActive || hasDontMatchError;
    (0, react_1.useEffect)(() => {
        const sub = form.model.subscribe(() => {
            if (passwordDontMatchErrorState.getValue()) {
                passwordDontMatchErrorState.setValue('');
            }
        });
        return () => {
            sub.unsubscribe();
        };
    }, [form.model, passwordDontMatchErrorState]);
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, onKeyDown: keyDownHandler },
        react_1.default.createElement(CreateUser_styles_1.StyledCreateUserFormContainer, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.end },
            react_1.default.createElement(CreateUser_styles_1.StyledCreateUserWrapper, { align: StackView_1.STACK_ALIGN.start, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s },
                react_1.default.createElement(CreateUser_styles_1.StyledCreateUserTitle, { size: Text_1.TEXT_SIZE.xl, trailer: hasMessages ? View_1.INDENT.none : View_1.INDENT.l }, texts.formTitle),
                hasError && react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, error),
                hasDontMatchError && (react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, passwordDontMatchErrorState.getValue())),
                isCapsLockActive && (react_1.default.createElement(Notification_1.Notification, { status: Notification_1.NOTIFICATION_STATUS.warning }, texts.warningCapsLockOn))),
            react_1.default.createElement(fields_1.TextField, { inlineLabel: true, helpTextWrap: true, size: common_1.CONTROL_SIZE.full, label: texts.labelLogin, field: form.fields.login, hasError: errorHighlight, onFocus: fieldFocusHandler, disabled: loading, controlRef: inputRef }),
            react_1.default.createElement(fields_1.PasswordField, { inlineLabel: true, label: texts.labelPassword, helpTextWrap: true, size: common_1.CONTROL_SIZE.full, field: form.fields.password, hasError: errorHighlight || hasDontMatchError, onFocus: fieldFocusHandler, disabled: loading, helpText: texts.helpTextPassword }),
            react_1.default.createElement(fields_1.PasswordField, { inlineLabel: true, helpTextWrap: true, size: common_1.CONTROL_SIZE.full, label: texts.labelPasswordConfirm, field: form.fields.passwordConfirm, onFocus: fieldFocusHandler, disabled: loading, hasError: errorHighlight || hasDontMatchError }),
            react_1.default.createElement(CreateUser_styles_1.StyledCreateUserWrapper, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.start },
                hasRememberMe && (react_1.default.createElement(fields_1.CheckboxField, { field: form.fields.rememberMe, label: texts.labelRememberMe, disabled: loading })),
                react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s, indentTop: hasRememberMe ? View_1.INDENT.none : View_1.INDENT.s, align: StackView_1.STACK_ALIGN.center },
                    react_1.default.createElement(CreateUser_styles_1.StyledCreateUserLoginButton, { onClick: submit, disabled: loading }, texts.actionLogIn),
                    loading && react_1.default.createElement(Spinner_1.Spinner, null))))));
});
//# sourceMappingURL=CreateUser.js.map